import { makeAutoObservable } from 'mobx'
import RootStore  from 'mobx-stores/root-store'
import { ShippingDTO } from 'models/shipping'
import { Api } from 'services'

export class ProductsShippingsStore {
  private rootStore:any
  private shippingApi: Api['shippingApi']

  constructor (rootStore:any) {
    this.rootStore = rootStore;
    this.shippingApi = rootStore.generalStore.api.shippingApi;
    makeAutoObservable(this);
  }

  // OBSERVABLES
  private brandShippings: ShippingDTO[] = [];

  // ACTIONS
  public setBrandShippings = (shippings: ShippingDTO[]): void => {
    this.brandShippings = shippings;
  }

  public setActiveStoreProp = (activeState: boolean, key: number, editMode?: boolean, productId?: number | string): void => {
    this.brandShippings[key] = {...this.brandShippings[key], active: activeState};
    if(editMode) {
      this.rootStore.viewProductsPageStore.updateProduct({shippings: [...this.setBrandingListForSave()]}, productId);
    }
  }

  // COMPUTED
  public get productBrandShippingsStore(): ShippingDTO[] {
    return this.brandShippings
  }

  getBrandShippings = (brandId: number | string, editActiveShippings?: ShippingDTO[]): void => {
    const { setLoadingOn, setLoadingOff, handleApiError } = this.rootStore.generalStore;
    setLoadingOn();
    this.shippingApi.getShipping(brandId)
      .then((shippings: ShippingDTO[]) => {
          this.setShippingsActivePropState(shippings, editActiveShippings);
        setLoadingOff();
      })
      .catch(error => {
        handleApiError(error);
        setLoadingOff();
      });
  }

  setShippingsActivePropState = (shippings: ShippingDTO[], editActiveShippings?: ShippingDTO[]): void => {
    let shippingOptions: ShippingDTO[];

    if(!!editActiveShippings) {
      editActiveShippings.forEach((shippingOption: ShippingDTO) => {
        shippingOption.active = true
        const shippingIndex = shippings.map(option => option.id).indexOf(shippingOption.id);
        shippings.splice(shippingIndex, 1);
      });
      shippings.forEach((shippingOption: ShippingDTO) => shippingOption.active = false);
      shippingOptions = [...editActiveShippings, ...shippings];
    } else {
      shippings.forEach((shippingOption: ShippingDTO) => shippingOption.active = true);
      shippingOptions = shippings;
    }

    this.setBrandShippings(shippingOptions)
  }

  setBrandingListForSave = (): ShippingDTO[] => {
    const brandShippings = JSON.stringify(this.brandShippings);
    const brandOptions = JSON.parse(brandShippings).filter(shippingOption => shippingOption.active);
    brandOptions.forEach(shippingOption => delete shippingOption.active);
    return brandOptions;
  }

}